import './TableMissionBDC.scss';

import { Button, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import BDC from '../../../Components/Docs/bdc';
import OrdreMission from '../../../Components/Docs/OdreMission';
import PropCommerciale from '../../../Components/Docs/PropCommerciale';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { dureeBdcEnum, sourceMissionEnum, StatutsMisionEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import {
    getNomPrenomClearFromPersoData,
    getStatutMissionEnCoursSiDateDebutPasEncoreCommencee,
    referenceOrdreMission,
    refPropositionCommerciale,
    searchLabelInEnumByValue,
    statutBdc,
} from '../../../Utils/utils';
import { getCommissionHTH, getMargeBrute, getMargeNet, getMontatantTTC } from '../../../Utils/utilsCraX';
import { MenuButtonOptionsRenouvelerModifier } from './MenuButtonOptionsRenouvelerModifier';

const AllAdminMissions = () => {
    const { addEuro4Decimal } = useNumberFormatting();

    // const { mission, setMission } = useGlobalContext();
    const [missions, setMissions] = useState();
    const axiosPrivate = useAxiosPrivate();
    const [selectedMission, setSelectedMission] = useState();
    const [openBdc, setOpenBdc] = useState(false);
    const [openOrdreMission, setOpenOrdreMission] = useState(false);
    const [openPropCommerciale, setOpenPropCommerciale] = useState(false);
    const navigate = useNavigate();
    const [missionsData, setMissionsData] = useState([]);
    const [role, setRole] = useState('');
    const location = useLocation();
    const [chargeRecrutementId,setChargeRecrutementId]=useState('');
    const {device}=useWindowSize();
    const { setBackdropOpen } = useUtilities();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');

    const [filtreMissionEncours, setFiltreMissionEncours] = useState(searchParams.get('filtreMissionEncours') === 'true');
    const [filtreMissionTermine, setFiltreMissionTermine] = useState(searchParams.get('filtreMissionTermine') === 'true');
    const { i18n } = useTranslation();
    const [selectedRow, setSelectedRow] = React.useState(null);

    const columns = [
        {
            field: 'missionId',
            title: i18n.t('Réf. Mission'),
        },

        {
            field: 'createdAt',
            title: i18n.t('Créée le'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.createdAt),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du Client'),
        },
        {
            field: 'clientId',
            title: i18n.t('Réf. Client'),
        },
        {
            field: 'source',
            title: i18n.t('Source'),
        },
        {
            field: 'AppelOffreId',
            title: i18n.t('Réf.Besoin'),
            cellStyle: {
                cellWidth: '15%',
            },
        },
        {
            field: 'titre',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statutMission',
            title: i18n.t('Statut mission'),
            render: rowData =>
                i18n.t(getStatutMissionEnCoursSiDateDebutPasEncoreCommencee(
                    searchLabelInEnumByValue(StatutsMisionEnum, (rowData?.statutMission)),
                    rowData?.dateDebutMission,
                    rowData?.isInterruptionEnCours
                )),
        },
        {
            field: 'statutBdc',
            title: i18n.t('Statut BDC'),
            render: rowData =>
                i18n.t(rowData?.statutBdc)
        },
        {
            field: 'troisP',
            title: 'Options',
            render: (rowData) => (
                <MenuButtonOptionsRenouvelerModifier
                    bdc={rowData}
                    getMissions={getMissions}
                />
            ),
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début mission'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateDebutMission),
            cellStyle: {
                cellWidth: '15%',
            },
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date fin mission'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateFinMission),
        },
        {
            field: 'expertId_',
            title: i18n.t('Réf. Expert'),
            cellStyle: {
                cellWidth: '15%',
            },
        },

        {
            field: 'nomExpert',
            title: i18n.t('Nom Expert'),
        },
        {
            field: 'refBdcClient',
            title: i18n.t('Réf.BDC/Client'),
            render: (rowData) => (
                <Button
                    variant="text"
                    onClick={() => {
                        console.log(rowData);
                        setSelectedMission(rowData);
                        setRole('client');
                        setOpenBdc(true);
                    }}
                >
                    {rowData?.bdcId}
                </Button>
            ),
        },
        {
            field: 'refBdcExpert',
            title: i18n.t('Réf.BDC/Expert'),
            render: (rowData) => (
                <Button
                    variant="text"
                    onClick={() => {
                        console.log(rowData);
                        setSelectedMission(rowData);
                        setRole('expert');
                        setOpenBdc(true);
                    }}

                >
                    {rowData?.bdcId + '-E'}
                </Button>
            ),
        },
        {
            field: 'refOrdreMission',
            title: i18n.t('Réf. ordre de mission'),
            render: (rowData) => (
                <Button
                    variant="text"
                    onClick={() => {
                        console.log(rowData);
                        setSelectedMission(rowData);
                        setOpenOrdreMission(true);
                    }}
                >
                    {rowData?.refOrdreMission}
                </Button>
            ),
        },
        {
            field: 'refPropCommerciale',
            title: i18n.t('Réf. proposition commerciale'),
            render: (rowData) => (
                <Button
                    variant="text"
                    onClick={() => {
                        console.log(rowData);
                        setSelectedMission(rowData);
                        setOpenPropCommerciale(true);
                    }}
                >
                    {rowData?.refPropCommerciale}
                </Button>
            ),
        },
        {
            field: 'localisation',
            title: i18n.t('Lieu'),
        },
        {
            field: 'refCmdClient',
            title: i18n.t('Réf.Commande Client'),
        },

        {
            field: 'dateDebBdc',
            title: i18n.t('Date début BDC'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateDebBdc)
        },
        {
            field: 'dateFinBdc',
            title: i18n.t('Date fin BDC'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateFinBdc)
        },
        {
            field: 'nbJoursBDC',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJoursBDC, 'j');
            }
        },
        {
            field: 'frequenceRenouvelement',
            title: i18n.t('Fréq.de renouvellement'),
            render: rowData =>
                i18n.t(searchLabelInEnumByValue(dureeBdcEnum, rowData?.frequenceRenouvelement))
        },
        {
            field: 'tjExpertHt',
            title: i18n.t('Tj/Expert (HT)'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.tjExpertHt);
            }
        },
        {
            field: 'tvaExpert',
            title: i18n.t('TVA Expert'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.tvaExpert || 0, '%');
            }
        },
        {
            field: 'tjExpertTTC',
            title: i18n.t('Tj/Expert (TTC)'),
            render: rowData => {
                return (addEuro4Decimal(getMontatantTTC(rowData.tjExpertHt, rowData.tvaExpert)));
            }
        },
        {
            field: 'commissionHTH',
            title: i18n.t('Commision appliquée'),
            render: rowData => {
                return (addEuro4Decimal(rowData.commissionHTH, '%'));
            }
        },
        {
            field: 'tjClientHt',
            title: i18n.t('Tj/Client (HT)'),
            render: rowData => {
                return (addEuro4Decimal(rowData.tjClientHt));
            }
        },
        {
            field: 'tvaClient',
            title: i18n.t('TVA Client'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.tvaClient || 0, '%');
            }
        },
        {
            field: 'tjClientTTC',
            title: i18n.t('Tj/Client (TTC)'),
            // tva: cra?.missionId?.tvaExpert,
            // tvaClient: cra?.missionId?.tvaClient,
            render: rowData => {
                return addEuro4Decimal(getMontatantTTC(rowData.tjClientHt, rowData.tvaClient));
            }
        },
        {
            field: 'margeBrut',
            title: i18n.t('Marge brute'),
            render: rowData => {
                return addEuro4Decimal(getMargeBrute(
                    rowData.tjClientHt,
                    rowData.tjExpertHt,
                ));
            }
        },
        {
            field: 'margeNet',
            title: i18n.t('Marge nette'),
            render: rowData => {
                return addEuro4Decimal(getMargeNet(
                    getMargeBrute(
                        rowData.tjClientHt,
                        rowData.tjExpertHt
                    ),
                    rowData.tjClientHt)
                );
                //avant TTC
                //return addEuro4Decimal(getMargeNet(
                //    getMargeBrute(
                //        getMontatantTTC(rowData.tjClientHt, rowData.tvaClient),
                //        getMontatantTTC(rowData.tjExpertHt, rowData.tvaExpert)
                //    ),
                //    getMontatantTTC(rowData.tjClientHt, rowData.tvaClient))
                //);
            }
        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
        {
            field: 'responsableOperationnel',
            title: i18n.t('Resp.Opérationnel'),
        },
        {
            field: 'responsableAchat',
            title: i18n.t('Resp.Achat'),
        },
        {
            field: 'responsableComptabilite',
            title: i18n.t('Resp.Comptabilité'),
        },
        {
            field: 'motifInterruption',
            title: i18n.t('Motif d\'interruption ou d\'annulation'),
            render: rowData => {
                return (
                    <Tooltip title={rowData.dateEffective ? formatDateJJMMYYYY(rowData.dateEffective) :''}>
                        <p style={{margin:'0px'}}>{rowData.motifInterruption}</p>
                    </Tooltip>
                );
            }
        },
    ];

    //* React Table Data Preparation
    useEffect(() => {
        getMissions();
    }, []);
    useEffect(() => {
        getMyInfos();
    }, []);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtremissiontermine') && !url.toLowerCase().includes('filtremissionencours') ){
            setFiltreMissionEncours(false);
            setFiltreMissionTermine(false);
            getMissions();
            getMyInfos();
        }
    }, [url]);

    useEffect(() => {
        getMissions();
        getMyInfos();
    }, [filtreMissionTermine,filtreMissionEncours]);

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get('admin/getMyInfos');
            if((response.data?.backOffice?.roles?.chargeRecrutement==1)){
                setChargeRecrutementId(response.data?.backOffice?._id);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const mapBDC = (mission,bdc,isLastBDC) => {
        return {
            // ...bdc,
            'isLastBDC': isLastBDC,
            'missionId': mission?.missionId,
            'nbJoursBDC': bdc?.nbJoursBDC,
            'id': mission?._id, //! we use this on renew/modify
            'bdcId': bdc.bdcId,
            'source': i18n.t(searchLabelInEnumByValue(sourceMissionEnum, mission?.sourceMission)),
            'esnId':mission?.esnId,
            'aoId': mission?.aoId ?? mission?.dossierId,
            'AppelOffreId': mission?.aoId?.aoId ?? mission?.dossierId?.dossierId,
            'titre': mission?.titre,
            'statutMission': mission?.statutMission,
            'createdAt': mission?.createdAt,
            'dateDebutMission': mission?.dateDebutMission,
            'dateFinMission': mission?.dateFinMission,
            'clientId': mission?.companyDataId?.clientId ??  mission?.esnId?.esnId,
            'xx':mission?.companyDataId?.donneeFacturation?.delaiPaiement ?? mission?.esnId?.donneeFacturation?.delaiPaiement,
            'localisation': mission?.localisation,
            'refOrdreMission': referenceOrdreMission(mission?.missionId),
            'refPropCommerciale': refPropositionCommerciale(mission?.missionId),
            'nomClient': mission?.companyDataId?.profileEntreprise?.nom ?? mission?.esnId?.profileEntreprise?.nom,
            'expertId_': mission?.expertId?.expertId,
            'expertId': mission?.expertId,
            'expert': mission?.expertId,
            'dateEffective':mission?.interruptionBackOffice?.dateEffective ?? '',
            'nomExpert': getNomPrenomClearFromPersoData(mission?.expertId?.persoData),
            'motifInterruption': mission?.interruptionBackOffice?.motifAcceptation ?? '', //?? mission?.interruptionBackOffice?.motifRejet
            'lengthBdc': mission?.BDCs.length,
            'refCmdClient': bdc?.refCmdClient,
            'refBdcClient': bdc?.bdcId,
            'refBdcExpert': bdc?.bdcId + '-E',
            // ? doit etre : en attente de validation - validee par l expert - valide par le client - validee par les deux.
            // resultats de traitements des deux status
            dateDebBdc: bdc?.dateDebutBDC,
            dateFinBdc: bdc?.dateFinBDC,
            frequenceRenouvelement: bdc?.frequenceRenouv,
            tjExpertHt: bdc?.tj, // * OLD getTjExpert(bdc?.tj),
            tjClientHt: bdc?.tjClient, // * OLD getTjClient(bdc?.tj, bdc?.commissionHTH)
            commissionHTH: getCommissionHTH({ tj: bdc.tj, tjClient: bdc?.tjClient }),
            'tvaExpert': bdc?.tauxTvaExpert ?? mission?.expertId?.entreprise?.tauxTva ?? mission?.esnExpertOwnerId?.donneeFacturation?.tauxTva,
            'tvaClient': bdc?.tauxTvaClient ?? mission?.companyDataId?.donneeFacturation?.tauxTva ?? mission?.esnId?.donneeFacturation?.tauxTva,
            //PS: Ajouter TVA
            // 'tjClientTTC': bdc?.tjClient,
            // * v2 with the attach function / even addEuro .. when we concatenate a result from a calcul ,, it gives a NaN ..
            // commissionHTH: attachUnitToValue('%',getCommissionHTH({ tj: bdc.tj, tjClient: bdc?.tjClient })), // getCommissionHTH({ tj: bdc.tj, tjClient: bdc?.tjClient }) + '%',
            // 'tvaExpert':  attachUnitToValue('%', mission?.expertId?.entreprise?.tauxTva) ,
            // 'tvaClient': attachUnitToValue('%', mission?.companyDataId?.donneeFacturation?.tauxTva),

            'ordreDeMission': mission?.ordreDeMission,
            'propositionCommerciale': mission?.propositionCommerciale,
            'margeBrut': ' ',
            'statutBdc': statutBdc(
                mission?.ordreDeMission?.statut,
                mission?.propositionCommerciale?.statut,
                mission?.statutMission,
                isLastBDC
            ),
            'BDCsOP': mission.BDCs,
            'BDCs': bdc,
            'companyDataId': mission?.companyDataId,
            'chargeRecrutement': getNomPrenomClearFromPersoData(bdc?.backOfficeId?.persoData),
            'responsableOperationnel': getNomPrenomClearFromPersoData(bdc?.responsableOperationnelId?.persoData ?? bdc?.responsableOperationnelEsnId?.persoData),
            'responsableAchat': getNomPrenomClearFromPersoData(bdc?.responsableAchatId?.persoData ?? bdc?.responsableAchatEsnId?.persoData),
            'responsableComptabilite': getNomPrenomClearFromPersoData(bdc?.responsableComptabiliteId?.persoData ?? bdc?.responsableComptabiliteEsnId?.persoData),
            // * l interruption est-il traiter ou pas , mais sans aucun info sur la dateEffective s'est passee ou pas encore, donc on a cree le statut intermidiare dans le backend [BD] dirrectement
            // isInterruptionTraited: (mission?.interruptionBackOffice?.wasAccepted == true ||
            //     mission?.interruptionBackOffice?.wasAccepted == false) &&
            //     (!mission?.interruptionClient?.isInterrupted && !mission?.interruptionExpert?.isInterrupted),
            // * isInterruptionEnCours =  encours de demande
            'esnExpertOwnerId':mission?.esnExpertOwnerId,
            isInterruptionEnCours: mission?.interruptionClient?.isInterrupted || mission?.interruptionExpert?.isInterrupted,
            // ...mission //! so risky 4 security + too many data crashed the app :(
        };

    };

    // useEffect(() => {
    //     if (missions) {
    //         let newData = [];
    //         if(filtreMissionEncours==true){
    //             missions.reverse().forEach((mission) => { //.slice(0,1)
    //                 mission.BDCs.forEach((bdc, index) => {
    //                     if(mission?.statutMission=='encours' || mission?.statutMission=='interruptionEnCours'){
    //                         // alert('CCA', mission?.interruptionBackOffice?.motifAcceptation);
    //                         let isLastBDC = mission.BDCs.length == index + 1;
    //                         console.log('mission',mission);
    //                         if(chargeRecrutementId && chargeRecrutementId==bdc?.backOfficeId?._id)
    //                             newData.push(mapBDC(mission,bdc,isLastBDC));
    //                         if(chargeRecrutementId=='')
    //                             newData.push(mapBDC(mission,bdc,isLastBDC));
    //                     }

    //                 });
    //             });
    //         }
    //         else if(filtreMissionTermine==true){
    //             missions.reverse().forEach((mission) => { //.slice(0,1)
    //                 mission.BDCs.forEach((bdc, index) => {
    //                     if(mission?.statutMission=='terminee' || mission?.statutMission=='interompu'){
    //                         // alert('CCA', mission?.interruptionBackOffice?.motifAcceptation);
    //                         let isLastBDC = mission.BDCs.length == index + 1;
    //                         console.log('mission',mission);
    //                         if(chargeRecrutementId && chargeRecrutementId==bdc?.backOfficeId?._id)
    //                             newData.push(mapBDC(mission,bdc,isLastBDC));
    //                         if(chargeRecrutementId=='')
    //                             newData.push(mapBDC(mission,bdc,isLastBDC));
    //                     }

    //                 });
    //             });
    //         }
    //         else{
    //             missions.reverse().forEach((mission) => { //.slice(0,1)
    //                 mission.BDCs.forEach((bdc, index) => {
    //                     // alert('CCA', mission?.interruptionBackOffice?.motifAcceptation);
    //                     let isLastBDC = mission.BDCs.length == index + 1;
    //                     console.log('mission',mission);
    //                     if(chargeRecrutementId && chargeRecrutementId==bdc?.backOfficeId?._id)
    //                         newData.push(mapBDC(mission,bdc,isLastBDC));
    //                     if(chargeRecrutementId=='')
    //                         newData.push(mapBDC(mission,bdc,isLastBDC));

    //                 });
    //             });
    //         }
    //         setMissionsData(newData);
    //     }
    // }, [missions,chargeRecrutementId]);

    useEffect(() => {
        if (!missions) return;

        const filterMission = (mission) => {
            const statutMission = mission?.statutMission;
            return (filtreMissionEncours && (statutMission === 'encours' || statutMission === 'interruptionEnCours')) ||
                   (filtreMissionTermine && (statutMission === 'terminee' || statutMission === 'interompu')) ||
                   (!filtreMissionEncours && !filtreMissionTermine);
        };

        const newData = missions.reduce((acc, mission) => {
            if (filterMission(mission)) {
                mission.BDCs.forEach((bdc, index) => {
                    const isLastBDC = mission.BDCs.length === index + 1;
                    if (!chargeRecrutementId || chargeRecrutementId === bdc?.backOfficeId?._id) {
                        acc.push(mapBDC(mission, bdc, isLastBDC));
                    }
                });
            }
            return acc;
        }, []);

        setMissionsData(newData);
    }, [missions, filtreMissionEncours, filtreMissionTermine, chargeRecrutementId]);

    const getMissions = async () => {
        try {
            setBackdropOpen(true);
            console.log('HELLO FROM the get Missions useEffect');
            const response = await axiosPrivate.get('/mission/getMissions', {
                // signal: controller.signal
            });
            console.log(response.data);
            setMissions(response.data.reverse());
            setBackdropOpen(false);
        } catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };

    return (
        <>
            <div className='frame5Profile'>{i18n.t('Gestion des missions')} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Missions et BDC')}</span> </div>

            <div className="HomeFrame">
                <h4 className="titlesociete">{i18n.t('Missions et BDC')}</h4>
                <div className="frame12TableMissionBDCAdmin">
                    <Button
                        variant="contained"
                        style={{
                            ...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}
                        }}
                        onClick={() => {
                            navigate('/admin/createMission');
                        }}
                    >
                        {i18n.t('Créer mission')}
                    </Button>
                </div>
                <MaterialTableComponent
                    columns={columns}
                    data={missionsData}
                    title={i18n.t('Missions et BDC')}
                    // search={false}
                    style={{ tableLayout: 'fixed' }}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                />
            </div>
            {openBdc &&
            <BDC
                handleClose={() => {
                    setOpenBdc(false);
                }}
                mission={selectedMission}
                open={openBdc}
                role={role}
            />}
            {openOrdreMission &&
            <OrdreMission
                handleClose={() => {
                    setOpenOrdreMission(false);
                }}
                mission={selectedMission}
                open={openOrdreMission}
            />}
            {openPropCommerciale &&
            <PropCommerciale
                handleClose={() => {
                    setOpenPropCommerciale(false);
                }}
                mission={selectedMission}
                open={openPropCommerciale}
            />}
        </>
    );
};

export default AllAdminMissions;
